module.exports = __webpack_public_path__ + "img/slide-bar-on_06.65062996.png";